<script>
    import FlexConfigInput from "./FlexConfigInput.svelte";

    export let formConfig = {};

    const handleCollapseInputChange = (event) => {
        const { instanceId, propertyName, value } = event.detail;

        if (formConfig[instanceId])
            formConfig[instanceId][propertyName] = value;
        else formConfig[instanceId] = { [propertyName]: value };
    };
</script>

<div class="flex flex-col gap-y-2">
    <p class="text-lg font-bold">Form:</p>
    <div class="flex flex-col gap-y-2">
        <FlexConfigInput
            title="Texts"
            instanceId="textConfig"
            config={{
                collapseArr: [
                    {
                        title: "Color",
                        inputType: "color",
                        inputValue: formConfig.textConfig?.color,
                        propertyName: "color",
                    },
                    {
                        title: "Font Size(pixel)",
                        inputType: "text",
                        inputValue: formConfig.textConfig?.fontSize,
                        propertyName: "fontSize",
                    },
                ],
            }}
            on:collapseInputChange={handleCollapseInputChange}
        />

        <FlexConfigInput
            title="Submit Button"
            instanceId="btnConfig"
            config={{
                collapseArr: [
                    {
                        title: "Color",
                        inputType: "color",
                        inputValue: formConfig.btnConfig?.textColor,
                        propertyName: "textColor",
                    },
                    {
                        title: "Font Size(pixel)",
                        inputType: "text",
                        inputValue: formConfig.btnConfig?.fontSize,
                        propertyName: "fontSize",
                    },
                    {
                        title: "Background Color",
                        inputType: "color",
                        inputValue: formConfig.btnConfig?.bgColor,
                        propertyName: "bgColor",
                    },
                    {
                        title: "Text",
                        inputType: "text",
                        inputValue: formConfig.btnConfig?.btnText,
                        propertyName: "btnText",
                    },
                ],
            }}
            on:collapseInputChange={handleCollapseInputChange}
        />
    </div>
</div>
